import ProductListResealedItem from "@components/ProductList/ProductListResealedItem";
import { useEffect, useRef, useState } from "react";

const getProductsPerRow = ({ listType = "default", width }) => {
  if (width < 640) return 2;

  if (listType === "wishlist") {
    return 3;
  }

  if (width < 1021) return 3;

  return 4;
};

const getProductsInCurrentRow = ({ products, index, productsPerRow }) => {
  const currentRowStartIndex =
    Math.floor(index / productsPerRow) * productsPerRow;
  const currentRowEndIndex = currentRowStartIndex + productsPerRow - 1;

  return products.slice(currentRowStartIndex, currentRowEndIndex + 1);
};

const ProductListResealed = ({ products, onProductClick }) => {
  const observerRef = useRef(null);
  const [width, setWidth] = useState();

  useEffect(() => {
    observerRef.current = new ResizeObserver((entries) => {
      setWidth(entries[0].contentRect.width);
    });

    observerRef.current.observe(document.querySelector("body"));

    return () => {
      observerRef.current.disconnect();
    };
  }, []);

  return (
    <ul className="Products flex flex-wrap relative -mx-1 sm:-mx-2">
      {products.map((product, i) => {
        const productsPerRow = getProductsPerRow({ width });

        const productsInCurrentRow = getProductsInCurrentRow({
          products,
          index: i,
          productsPerRow,
        });

        const hasColorVariationsInCurrentRow = productsInCurrentRow.some(
          (p) =>
            p.configurable_options?.length &&
            p.configurable_options.find(
              (option) => option.attribute_code === "culoare_global"
            )
        );

        return (
          <ProductListResealedItem
            key={product.id + "-" + i}
            product={product}
            onProductClick={onProductClick}
            hasColorVariationsInCurrentRow={hasColorVariationsInCurrentRow}
          />
        );
      })}
    </ul>
  );
};

export default ProductListResealed;
